import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbstractControl, AsyncValidatorFn } from '@angular/forms';
import { lastValueFrom } from 'rxjs';
import { ResponseData, formValidator } from 'src/app/helper/interface/response';

@Injectable({
  providedIn: 'root',
})
export class AsyncApiService {
  constructor(private http: HttpClient) {}
  isMobileUnique(id: any, skipId: any = '') {
    return lastValueFrom(
      this.http.get(
        `/users/isMobileUniqueStaff/${id}${skipId ? '/' + skipId : ''}`
      )
    );
  }

  isUniqueMobileValidation(validator: formValidator): AsyncValidatorFn {
    return (control: AbstractControl) => {
      const key: any = validator.name,
        val = control.value,
        error = Object.keys(control?.errors || {}).some((a) => a !== key),
        formValue = control.parent?.value,
        skipVal =
          formValue[validator.skipAsync?.key || ''] ||
          validator.skipAsync?.value ||
          '',
        full_code = `${formValue.country_code || '91'}${val}`,
        promise = new Promise<any>((resolve, reject) => {
          if (!error && val) {
            this.isMobileUnique(full_code, skipVal)
              .then((res: ResponseData) => {
                const isNotUnique = res?.result?.isNotUnique ?? true;
                let result =
                  isNotUnique == true
                    ? { [key]: true, updateOn: 'blur' }
                    : null;
                resolve(result);
              })
              .catch(() => resolve({ [key]: true, updateOn: 'blur' }));
          } else {
            resolve(null);
          }
        });
      return promise;
    };
  }

  isUniqueValidation(validator: formValidator): AsyncValidatorFn {
    return (control: AbstractControl) => {
      const key: any = validator.name,
        val = control.value,
        error = Object.keys(control?.errors || {}).some((a) => a !== key),
        formValue = control.parent?.value || {},
        skipVal =
          formValue[validator.skipAsync?.key || ''] ||
          validator.skipAsync?.value ||
          '',
        promise = new Promise<any>((resolve, reject) => {
          if (!error && val) {
            this.http
              .get<ResponseData>(
                `/users/isUnique/${validator.colName}/${val}${
                  skipVal ? '/' + skipIdToValue(skipVal) : ''
                }`
              )
              .toPromise()
              .then((res: ResponseData | any) => {
                const isNotUnique = res?.result?.isNotUnique ?? true;
                let result =
                  isNotUnique == true
                    ? { [key]: true, updateOn: 'blur' }
                    : null;
                resolve(result);
              })
              .catch(() => resolve({ [key]: true, updateOn: 'blur' }));
          } else {
            resolve(null);
          }
        });
      return promise;
    };
  }
}

function skipIdToValue(skipVal: any) {
  return typeof skipVal == 'object' ? skipVal.id : skipVal;
}
